<script setup lang="ts">
import { ref } from 'vue';
import { useStore } from 'vuex';

import Modal from '@/components/shared/Dialog.vue';
import ModalControls from '@/components/modals/shared/ModalControls.vue';

// ------- Store & State -------
interface Props {
  dismissable: boolean;
}
const props = defineProps<Props>();
const store = useStore();

const loading = ref(false);
const isModalVisible = ref(true);

// ------- Methods -------
const handleAgreeButtonPressed = async () => {
  loading.value = true;

  await store.dispatchApiAction('UPDATE_USER', {
    agreedToKyc: true,
  });

  isModalVisible.value = false;
  loading.value = false;
};
</script>

<template>
  <Modal
    v-model:visible="isModalVisible"
    :header="$t('components.modalIdentityVerification.identityVerification')"
    :modal="true"
    :draggable="false"
    :closable="false"
    :dismissableMask="props.dismissable"
    append-to="self"
  >
    <p :class="$style.description">
      {{ $t('components.modalIdentityVerification.serviceAgreement') }}
    </p>

    <template #footer>
      <ModalControls
        :buttons="[
          {
            text: 'Agree',
            action: () => handleAgreeButtonPressed(),
            classes: ['button-width'],
            attributes: { loading: loading, disabled: loading },
          },
        ]"
      />
    </template>
  </Modal>
</template>

<style lang="less" module>
.description {
  width: 100%;
  max-width: 665px;
  text-align: left;
  margin: 0 0 40px 0;
}
</style>
